var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"MsgManager"}},[_c('appHeader',{attrs:{"targetRouterName":_vm.route,"title":'訊息管理'}}),_c('router-view',{staticClass:"content-body-hasFooter"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }